export enum ACCEPTED_MEDIA_TYPES {
  'APPLICATION/JSON' = 'application/json',
  'TEXT/JAVASCRIPT' = 'text/javascript',
  'TEXT' = 'text',
  'TEXT/SVG' = 'text/svg',
  'IMAGE/SVG+XML' = 'image/svg+xml'
}